import { withErrorBoundary } from '@sentry/react';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useQuery } from 'urql';
import { assets } from '../../assets';
import Button from '../../components/buttons/button';
import { BlurredContainer } from '../../components/containers/containers';
import DefaultScreen from '../../components/containers/default-screen';
import StyledInput from '../../components/inputs/styled-input';
import { Fallback } from '../../components/utils/error-boundary';
import { GraphqlOperations } from '../../logic/graphql/operations';
import { Query } from '../../logic/graphql/types/types';
import { Paths } from '../../navigation/paths';
import { FormattedMessage, useIntl } from 'react-intl';

const LoginSettings = (): JSX.Element => {
  const history = useHistory();
  const intl = useIntl();
  const result = useQuery<Query>({
    query: GraphqlOperations.queries.getUserName.queryString,
  })[0];
  const { data } = result;
  const user = data?.getUser;

  const handleChangeClick = (): void => {
    history.push(Paths.password_change);
  };

  const handleContactClick = (): void => {
    history.push(Paths.contact);
  };

  return (
    <DefaultScreen
      background={assets.images.profile_bg}
      title={intl.formatMessage({ id: 'profilePage.settings.loginSettings.title' })}
      backUrl={Paths.settings}
    >
      <BlurredContainer>
        <p className="text-14 mb-5">
          <FormattedMessage id="profilePage.settings.loginSettings.description_a" />
          <a onClick={handleContactClick} href={Paths.contact}>
            <FormattedMessage id="profilePage.settings.loginSettings.description_b" />
          </a>
        </p>
        <StyledInput placeholder="felhasználónév" value={user?.email} disabled />
        <StyledInput placeholder="jelszó" value="••••••••" disabled />
        <Button onClick={handleChangeClick}>
          <FormattedMessage id="profilePage.settings.loginSettings.changePasswordButton" />
        </Button>
      </BlurredContainer>
    </DefaultScreen>
  );
};

export default withErrorBoundary(LoginSettings, { fallback: Fallback });
